import { graphql } from 'react-relay';

export const surgeryTimeLineFragment = graphql`
  fragment SurgeryTimelineFragment on Hospital {
    name
    id
    operatingRooms(first: $numberOfOperatingRooms) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
